import React, { Component } from 'react'
import {
  getSonePersonalDetails
} from '../../services/vu'
import { Link, Redirect, withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { getConfiguration } from '../../helpers/configuration'
import {
  APPLICATION_ID_SESSION_STORAGE_KEY,
  APPLICATION_LINE_ID_SESSION_STORAGE_KEY,
  getAttributeFromOfferStaticInfo,
  getOfferApplicationId,
  getOffersStaticInfoCache,
  offerStaticInfoCache
} from '../../helpers/offer'
import Loading from '../tags/Loading'
import { setSessionProperty } from '../../helpers/sessionProperties'

class Offers extends Component {
  constructor(props) {
    super(props)

    this.state = {
      loading: true,
      error: false,
      previousOfferSubmission: false
    }
  }

  componentDidMount() {
    let offers = getOffersStaticInfoCache()

    if (offers.length >= 2) {
      this.stopLoading()
      const courseCode = this.getSelectedCourseId()
      offerStaticInfoCache(offers, courseCode)
    } else {
      let offer = offers[0]

      setSessionProperty(
        APPLICATION_ID_SESSION_STORAGE_KEY,
        null,
        offer.applicationId
      )
      setSessionProperty(
        APPLICATION_LINE_ID_SESSION_STORAGE_KEY,
        null,
        offer.applicationLineId
      )

      offerStaticInfoCache(offer, getOfferApplicationId())

      Promise.all([getSonePersonalDetails()])
        .then(([personalDetails]) => {
          this.stopLoading({
            personalDetails: personalDetails,
            previousOfferSubmission:
              getAttributeFromOfferStaticInfo('outcomeCode') !== 'NA'
          })
        })
        .catch(error => {
          this.stopLoading({
            error: true
          })
        })
    }
  }

  stopLoading = (newState = {}) => {
    this.setState({
      loading: false,
      ...newState
    })
  }

  render() {
    if (this.state.loading) {
      return <Loading />
    }

    if (this.state.previousOfferSubmission) {
      return (
        <Redirect
          to={{ pathname: getConfiguration('baseUrl') + '/offer/thankyou' }}
        />
      )
    }

    return (
      <Redirect
        to={{ pathname: getConfiguration('baseUrl') + '/offer/accept' }}
      />
    )
  }
}

export default Offers
